import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { connect } from 'react-redux';
import {
    fetchSubscriptionsForAdminGrid
} from '../../../../../Redux/Actions/Admin/ManageSubscriptionActions';
import { CSVLink } from "react-csv";
import { Alert } from 'reactstrap';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import cellWithEditing from './CellWithEditing';
import SubscriptionForm from './SubscriptionForm';
import Search from '../../../Search';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import { ROOT_API_URL } from '../../../../../api-config';
import { SubscriptionsLoader } from './SubscriptionsLoader';
import axios from 'axios';
import '../ManageUsers/ManageUser.scss';
import { auth } from '../../../../../services/auth.service';
import Modal from 'react-modal';
import DialogContainer from './Dialogs/DialogContainer';

const FileDownload = require('js-file-download');

class ManageSubscriptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSubmitted: false,
            subscriptionInEdit: {},
            isPopupVisible: false,
            colors: { data: [], total: 0 },
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: []
                },
                sort: [{ field: "MagazineSubscriptionId", dir: "asc" }]
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""
        };
    }

    dataStateChange = (e) => {

        if (e.data && e.data.filter && e.data.filter.filters) {
            var filters = e.data.filter.filters;

            for (var i = 0; i < filters.length; i++) {
                if (filters[i].field && (filters[i].field == "ExpirationDate" || filters[i].field == "StartDate")) {
                    var operator = filters[i].operator;

                    if ((operator == "gt" || operator == "gte") && !filters[i].value) {

                        filters[i].value = new Date('January 01, 1900');

                    } else if ((operator == "lt" || operator == "lte") && !filters[i].value) {

                        var currentDatetime = new Date();

                        filters[i].value = new Date(Date.UTC(currentDatetime.getFullYear(), currentDatetime.getMonth(), currentDatetime.getDate()));

                    }
                } else if (filters[i].field && (filters[i].field == "TransactionIdInt" || filters[i].field == "MagazineSubscriptionId")) {
                    var operator = filters[i].operator;

                    if (!filters[i].value && (operator == "lt" || operator == "lte" || operator == "gt" || operator == "gte")) {

                        filters[i].value = 0;

                    }

                } else if (filters[i].value == null) {
                    filters[i].value = "";
                }
            }
        }

        this.setState({
            ...this.state,
            dataState: e.data
        });
    }

    dataRecieved = (subscriptionsFetched) => {
        this.setState({
            ...this.state,
            subscriptions: subscriptionsFetched,
            isLoading: false
        });

        if (subscriptionsFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
            let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
        }
        else if (subscriptionsFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
            document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
        }
    }

    edit = (dataItem) => {
        this.setState({
            subscriptionInEdit: Object.assign({}, dataItem),
            isNewForm: true,
            isPopupVisible: true
        });
    };

    cancel = () => {
        this.setState({ isPopupVisible: false })
    };

    stringifyObj = (arr) => {
        let t = [...arr];
        if (!t) {
            return null;
        }
        else {
            for (var i = 0; i < t.length; i++) {
                var element = { ...t[i] };
                if (element["field"] == "OrderDate") {
                    let date = element.value;
                    if (!date) {
                        date = "0001/01/01";
                    }
                    else {
                        date = (date + '').split(" ");
                        let day = date[2] + '';
                        let year = date[3] + '';
                        let month = "01";
                        switch (date[1]) {
                            case "Jan":
                                month = "01";
                                break;
                            case "Feb":
                                month = "02";
                                break;
                            case "Mar":
                                month = "03";
                                break;
                            case "Apr":
                                month = "04";
                                break;
                            case "May":
                                month = "05";
                                break;
                            case "Jun":
                                month = "06";
                                break;
                            case "Jul":
                                month = "07";
                                break;
                            case "Aug":
                                month = "08";
                                break;
                            case "Sep":
                                month = "09";
                                break;
                            case "Oct":
                                month = "10";
                                break;
                            case "Nov":
                                month = "11";
                                break;
                            case "Dec":
                                month = "12";
                                break;
                        }
                        date = year + "/" + month + "/" + day;
                        element["value"] = date;
                    }
                }
                else {
                    for (var key in t[i]) {
                        element[key] = element[key] + '';
                    }
                }
                t[i] = element;
            }
            return t;
        }
    }

    exportToExcel = () => {
        var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
        var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
        var KendoGridQuery = {
            Filters: Filters ? Filters.slice() : [],
            Sorts: Sorts ? Sorts.slice() : []
        }

        axios.get(ROOT_API_URL + "/ManageMagazineSubscriptions/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
            .then((response) => {
                FileDownload(response.data, 'Subscriptions.csv');
            }).catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to export to excel.';

                this.setState({
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            });
    }

    addNew = () => {
        this.setState({
            isPopupVisible: true,
            subscriptionInEdit: {}
        });
    }
    new = (model) => {
        let newModel = {
            companyName: model.companyName,
            email: model.email,
            firstName: model.firstName,
            lastName: model.lastName,
            mailingAddress1: model.mailingAddress1,
            mailingAddress2: model.mailingAddress2,
            mailingCity: model.mailingCity,
            mailingZip: model.mailingZip,
            phone: model.phone,
            preferredMailingName: model.preferredMailingName,
            isSubscribed: false,
            MailingStateId: model.state.id
        }
        console.log(newModel)
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: []
                },
                sort: [{ field: "MagazineSubscriptionId", dir: "asc" }]
            },
        });
        axios
          .post(`${ROOT_API_URL}/ManageMagazineSubscriptions/CreateMagazineSubscription`, newModel, { headers: auth.authHeader() })
          .then((response) => {
              this.setState({
                  isSubmitted: false
              })
          })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to create the subscription.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            });
    }

    save = (model) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: []
                },
                sort: [{ field: "MagazineSubscriptionId", dir: "asc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManageMagazineSubscriptions/SaveSubscription`, model, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to save the subscription.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            });
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }

    render() {
        return (
            <div id={"subscriptions-grid"}>
                <AdminHeader />
                {this.state.isLoading ?
                    (<div>
                        <IsLoading message="Loading subscriptions" />
                    </div>

                    ) :
                    (
                        <div>
                            <Alert
                                color={this.state.alertColor}
                                isOpen={this.state.alertVisible}
                                toggle={() => {
                                    this.setState({ alertVisible: false, alertMessage: "" })
                                }}
                            >
                                {this.state.alertMessage}
                            </Alert>
                            <Grid
                                filterable={true}
                                sortable={true}
                                pageable={true}
                                total={this.state.subscriptions.total}
                                {...this.state.dataState}
                                {...this.state.subscriptions}
                                onDataStateChange={this.dataStateChange}
                                resizable
                                reorderable={true}
                            >
                                <GridToolbar>
                                    <div className="admin-grid-toolbar-box2">
                                        <button onClick={this.addNew} className="admin-k-button">
                                            <i className="fas fa-plus-circle"></i>
                                            <span>ADD NEW</span>
                                        </button>
                                        <a id="excel-ref" href={ROOT_API_URL + "/ManageMagazineSubscriptions/ExportToExcel"} display="none" download></a>
                                        <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                                            <i className="fas fa-file-export"></i>
                                            EXPORT TO EXCEL
                                        </button>
                                    </div>
                                </GridToolbar>
                                <Column filterable={false} cell={cellWithEditing(this.edit, this.toggleActive)}/>
                                <Column field="MagazineSubscriptionId" title="Subscription ID" filter="numeric" />
                                <Column field="TransactionIdInt" title="Transaction ID" filter="numeric" />
                                <Column field="SubscriptionType" title="Type" filter="text" />
                                <Column field="SubscriptionStatus" title="Status" filter="text" />
                                <Column field="StartDate" title="Start Date"
                                    filter="date"
                                    cell={(props) => (
                                        <td>
                                            {props.dataItem.StartDate.substring(0, 10)}
                                        </td>

                                    )} />
                                <Column field="ExpirationDate" title="Expiration Date"
                                    filter="date"
                                    cell={(props) => (
                                        <td>
                                            {props.dataItem.ExpirationDate.substring(0, 10)}
                                        </td>

                                    )} />
                                <Column field="FirstName" title="First Name" filter="text" />
                                <Column field="LastName" title="Last Name" filter="text" />
                                {/*<Column field="CompanyName" title="Company" filter="text" />
                                <Column field="PreferredMailingName" title="Preferred Mailing Name" filter="text" />
                                <Column field="MailingAddress1" title="Address 1" filter="text" />
                                <Column field="MailingAddress2" title="Address 2" filter="text" />
                                <Column field="MailingCity" title="City" filter="text" />
                                <Column field="State" title="State" filter="text" />
                                <Column field="MailingZip" title="Zip" filter="text" />
                                <Column field="Phone" title="Phone" filter="text" />*/}
                                <Column field="Email" title="Email" filter="text" />
                            </Grid>
                        </div>
                    )
                }
                <div>
                    {!this.state.isSubmitted ?
                        <SubscriptionsLoader
                            dataState={this.state.dataState}
                            onDataRecieved={this.dataRecieved}
                        />
                        : ""
                    }
                </div>
                <div>
                    {
                        this.state.isPopupVisible ? (
                            <SubscriptionForm
                                dataItem={this.state.subscriptionInEdit}
                                save={this.save}
                                new={this.new}
                                cancel={this.cancel}
                            />
                        ) : ""
                    }
                    {<div>
                        <Modal
                            isOpen={this.state.isPopupVisible}
                            onRequestClose={this.cancel}
                            contentLabel="Example Modal"
                            ariaHideApp={false}
                            style={{
                                content: {
                                    top: '50%',
                                    left: '50%',
                                    right: 'auto',
                                    bottom: 'auto',
                                    marginRight: '-50%',
                                    minWidth: '80vw',
                                    maxWidth: '80vw',
                                    minHeight: '80vh',
                                    maxHeight: '80vh',
                                    overflow: 'auto',
                                    transform: 'translate(-50%, -50%)',
                                    borderRadius: '5px'
                                }
                            }}
                        >
                            <DialogContainer
                                dataItem={this.state.subscriptionInEdit}
                                save={this.save}
                                new={this.new}
                                cancel={this.cancel}
                            />
                        </Modal>
                    </div>}
                </div>
            </div>

        );
    }
}

function mapStateToProps(state) {
	return {
		common: state.common
	};
}

export default connect(mapStateToProps, {})(ManageSubscriptions);



